import React from "react";
import { modalSubmitBtnColor, modalCancelBtnColor } from "../constant/const";
import ModalUi from "../primitives/ModalUi";

const CommonDeleteModal = ({
  isOpen,
  title = "Delete",
  message,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <ModalUi isOpen title={title} handleClose={onCancel}>
      <div className="m-[20px]">
        <div className="text-lg font-normal text-black">
          {message || "Are you sure you want to delete?"}
        </div>

        <hr className="bg-[#ccc] mt-4" />

        <div className="flex items-center mt-3 gap-2">
          <button
            onClick={onConfirm}
            className="px-4 py-1.5 text-white rounded shadow-md focus:outline-none"
            style={{ backgroundColor: modalSubmitBtnColor }}
          >
            Yes
          </button>

          <button
            onClick={onCancel}
            className="px-4 py-1.5 text-black border border-[#ccc] rounded shadow-md focus:outline-none"
            style={{ backgroundColor: modalCancelBtnColor }}
          >
            No
          </button>
        </div>
      </div>
    </ModalUi>
  );
};

export default CommonDeleteModal;
